import { render, staticRenderFns } from "./StorageLocationsTable.vue?vue&type=template&id=5c005c48&scoped=true"
import script from "./StorageLocationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageLocationsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StorageLocationsTable.vue?vue&type=style&index=0&id=5c005c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c005c48",
  null
  
)

export default component.exports